import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule, HttpLoaderFactory } from "./shared/shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { ToastrModule } from "ngx-toastr";
import { DecimalPipe, registerLocaleData } from "@angular/common";
import localePt from '@angular/common/locales/pt';

import { CookieService } from "ngx-cookie-service";
import "hammerjs";
import "mousetrap";
import { AuthGuard } from "./shared/guard/auth.guard";
import { authInterceptorProviders } from "./shared/interceptor/auth.interceptor";
registerLocaleData(localePt);
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [CookieService, DecimalPipe, { provide: LOCALE_ID, useValue: 'pt-BR' }, AuthGuard, authInterceptorProviders],
  bootstrap: [AppComponent],
})
export class AppModule {}